import { css } from '@emotion/react';
import { createStyles } from '@mui/material/styles';

export const profileWrapperStyle = css`
  flex: 1;
  padding: 1rem;
  display: flex;
  flex-direction: column;
`;

export const profileAnalyticStyled = css`
  border: 0.1rem solid #c4c4c4;
  border-radius: 0.1rem;
  display: flex;
  padding: 1.5rem;
  align-items: center;
`;

export const headerStyle = createStyles({
  fontWeight: 'bold',
  marginBottom: '2rem',
});

export const analyticInfoRowStyle = css`
  display: flex;
  flex: 1;
  margin: 1rem;
`;

export const analyticInfoStyle = css`
  display: flex;
  flex-direction: column;
  justify-content: center;
  flex: 1;
`;
